
import { Routes } from '@angular/router';
import { ADMIN_PATH } from './admin/admin-path';

export const routes: Routes = [
  // The quote form is the landing page; the former home page lives at /accueil.
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'devis'
  },
  {
    path: 'accueil',
    loadComponent: () => import('./pages/home/home.component').then(m => m.HomeComponent)
  },
  {
    path: 'devis',
    loadComponent: () => import('./pages/demande-devis/demande-devis.component').then(m => m.DemandeDevisComponent)
  },
  {
    path: 'realisation',
    loadComponent: () => import('./pages/realisation/realisation.component').then(m => m.RealisationComponent)
  },
  // Private: the sales space. Its address is in admin-path.ts; "/admin" falls through to the form like any unknown page.
  {
    path: ADMIN_PATH,
    loadComponent: () => import('./admin/admin.component').then(m => m.AdminComponent)
  },

  {
    path: '**',
    redirectTo: 'devis'
  }
];
